import { render, staticRenderFns } from "./MessageHead.vue?vue&type=template&id=5d31cec7&scoped=true&"
import script from "./MessageHead.vue?vue&type=script&lang=js&"
export * from "./MessageHead.vue?vue&type=script&lang=js&"
import style0 from "./MessageHead.vue?vue&type=style&index=0&id=5d31cec7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31cec7",
  null
  
)

export default component.exports